import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(default)/error.tsx");
